const ERP_BULK_INDENT_ERRORS = {
  INVALID_UNIT_VALUE: 'Unit value is empty.',
  INVALID_MATERIAL_SCHEMA: 'Material schema is empty.',
  DROP_OFF_EMPTY: 'Drop Off is empty.',
  EMPTY_INPUT: 'Input is empty.',
};

module.exports = {
  ERP_BULK_INDENT_ERRORS,
};
